import * as React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

type Props = {
  children: React.ReactNode | React.ReactNodeArray;
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fafafa',
    padding: '16px',
    borderRadius: '8px',
  },
}));

export function PersonInputGroup(props: Props) {
  const classes = useStyles();

  return <div className={classes.root}>{props.children}</div>;
}
